export default "__VITE_ASSET__94a29b1e__"